'use client';

import { type ReactNode, useEffect, useState } from 'react';

import { DatadogReadyProvider } from '@/auth-src/contexts/DatadogReadyContext';
import { initDatadog } from '@/auth-src/lib/datadog';

export function DatadogInit({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const loadDatadogConfig = async () => {
      try {
        const response = await fetch('/auth-app/api/dd-config');
        if (!response.ok) {
          console.error('Failed to fetch Datadog config:', response.statusText);
          return;
        }
        const config = await response.json();
        initDatadog(config);
        setReady(true);
      } catch (error) {
        console.error('Error initializing Datadog:', error);
      }
    };

    void loadDatadogConfig();
  }, []);

  return <DatadogReadyProvider value={ready}>{children}</DatadogReadyProvider>;
}
